module.exports = __webpack_public_path__ + "img/taxOnlineChange.67525807.png";